import { HTTPVerbs as o } from "@nextgen-web-framework/core";
function p(t, n, r, e) {
  return {
    url: `/comproductas/${t}/products/${n}`,
    method: o.GET,
    headers: {
      "Content-Type": "application/json",
      ...r && { "Accept-Language": r },
      ...e && { "X-Amway-Channel": e }
    },
    retries: 0
  };
}
function u(t) {
  return {
    url: `/comproductas/${t}/products`,
    method: o.GET,
    headers: {
      "Content-Type": "application/json"
    },
    retries: 0
  };
}
export {
  u as getProductArrayReqObj,
  p as getProductReqObj
};
//# sourceMappingURL=productEndPoints.js.map
